import { render, staticRenderFns } from "./BaseDisplayMessage.vue?vue&type=template&id=bc0c6d58&scoped=true&"
import script from "./BaseDisplayMessage.vue?vue&type=script&lang=js&"
export * from "./BaseDisplayMessage.vue?vue&type=script&lang=js&"
import style0 from "./BaseDisplayMessage.vue?vue&type=style&index=0&id=bc0c6d58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0c6d58",
  null
  
)

export default component.exports